import React, { Component } from 'react'

import { connect } from 'react-redux'
import { snackbarDispose } from '../../reducers/snackbar/action'
import translator from '../../translate'
import { withSnackbar } from 'notistack'
import Preloader from '../../components/preloader'
// material
import { styled, makeStyles } from '@material-ui/core/styles'
import { Box, Card, Container, Typography, Link, Divider } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
// hooks
// routes
// components
import Page from '../../components/Page'
import { MHidden } from '../../components/@material-extend'
import { RegisterForm } from '../../components/authentication/register'
import AuthFirebaseSocials from '../../components/authentication/AuthFirebaseSocial'

// ----------------------------------------------------------------------

const logos = Array.from({ length: 23 }, (_, i) => 23 - i)

const useStyles = makeStyles((theme) => ({
    marqueeContainer: {
        width: '100%',
        position: 'relative',
        maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
        WebkitMaskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
        marginBottom: theme.spacing(3),
        '&:hover $marqueeGroup': {
            animationPlayState: 'paused',
        },
    },
    marqueeContent: {
        display: 'flex',
        overflow: 'hidden',
        userSelect: 'none',
    },
    marqueeGroup: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(10),
        minWidth: '100%',
        animation: 'marqueeScroll 60s linear infinite',
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
    },
}))

const LogosMarquee = () => {
    const classes = useStyles()
    return (
        <div className={classes.marqueeContainer}>
            <style>
                {`
                    @keyframes marqueeScroll {
                        from { transform: translateX(0); }
                        to { transform: translateX(-100%); }
                    }
                `}
            </style>
            <div className={classes.marqueeContent}>
                <div className={classes.marqueeGroup}>
                    {logos.map((logo, index) => (
                        <Box
                            component="img"
                            key={index}
                            src={`/assets/login-logos/${logo}.svg`}
                            alt={`logo-${logo}`}
                            sx={{ height: 32, width: 'auto', objectFit: 'contain' }}
                        />
                    ))}
                </div>
                <div className={classes.marqueeGroup} aria-hidden="true">
                    {logos.map((logo, index) => (
                        <Box
                            component="img"
                            key={index}
                            src={`/assets/login-logos/${logo}.svg`}
                            alt={`logo-${logo}`}
                            sx={{ height: 32, width: 'auto', objectFit: 'contain' }}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

const RootStyle = styled(Page)(({ theme }) => ({
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: '#fff',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    '&::before': {
        content: '""',
        position: 'absolute',
        bottom: '-20%',
        right: '-15%',
        width: '839px',
        height: '839px',
        borderRadius: '839px',
        background: 'linear-gradient(180deg, rgba(254, 225, 80, 0.50) 0%, rgba(225, 251, 255, 0.50) 100%)',
        filter: 'blur(200px)',
        zIndex: 0,
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: '-10%',
        right: '-10%',
        width: '467.584px',
        height: '467.584px',
        borderRadius: '467.584px',
        background: '#DFD0FF',
        filter: 'blur(229.20791625976562px)',
        zIndex: 0,
    },
}))

const LeftPanel = styled(Box)(({ theme }) => ({
    flex: 1,
    paddingTop: '40px',
    paddingBottom: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
}))

const FormCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    padding: '72px 48px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '40px',
    borderRadius: '24px',
    background: '#FFF',
    boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
    width: '520px',
    maxWidth: '100%',
    borderTop: `6px solid ${theme.palette.primary.main}`,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
        padding: '48px 24px',
        gap: '24px',
    },
}))

// ----------------------------------------------------------------------

class McgSignup extends Component {
    render() {
        const { process } = this.props
        return (
            <RootStyle title="Sign Up | Mini-Course Generator">
                {process && <Preloader process={process} />}

                <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>

                    {/* Blue Blur Blob */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '3%',
                            right: '20%',
                            width: '300px',
                            height: '300px',
                            background: '#0094FF',
                            filter: 'blur(150px)',
                            borderRadius: '9999px',
                            zIndex: -1,
                            opacity: 0.6,
                        }}
                    />

                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' }, alignItems: 'center' }}>
                        <LeftPanel>
                            <Box sx={{ width: '100%', maxWidth: 540 }}>
                                <Typography sx={{
                                    color: { xs: '#002E47', md: '#0B1D2E' },
                                    fontFamily: 'Inter',
                                    fontSize: { xs: '24px', md: '44px' },
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    lineHeight: { xs: '32px', md: '1.5' },
                                    letterSpacing: { xs: '-0.48px', md: '-0.088px' },
                                    marginBottom: { xs: '32px', md: '40px' },
                                    textAlign: { xs: 'center', md: 'left' }
                                }}>
                                    Trusted by over{' '}
                                    <u style={{ textDecoration: 'none', backgroundImage: 'linear-gradient(transparent 60%, #FFE14D 60%)', paddingBottom: '2px' }}>20,000</u>
                                    <br />
                                    Training Providers
                                </Typography>

                                <LogosMarquee />
                                <Divider sx={{ my: '40px', background: '#919EAB', height: '1px', display: { xs: 'none', md: 'block' } }} />

                                <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column', }}>
                                    {[
                                        'AI-Native, Interactive e-Learning Authoring',
                                        'Agile and Learner-Friendly LMS',
                                        'Customer Academy Management',
                                        'In-App, Contextual Training'
                                    ].map((text, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleIcon color="primary" sx={{ mr: 1, fontSize: 20 }} />
                                            <Typography sx={{
                                                color: '#0B1D2E',
                                                fontFamily: 'Inter',
                                                fontSize: '18px',
                                                fontStyle: 'normal',
                                                fontWeight: 400,
                                                lineHeight: '2'
                                            }}>
                                                {text}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </LeftPanel>

                        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <FormCard>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', alignSelf: 'flex-start', mb: { xs: 0, md: 0 } }}>
                                    <Box component="img" src="/assets/mcg-icon.svg" sx={{ width: 40, height: 40 }} />
                                    <Box component="img" src="/assets/mcg-text.svg" sx={{ width: '162.667px', height: 40 }} />
                                </Box>
                                <Box sx={{ width: '100%', textAlign: 'left' }}>
                                    <Typography sx={{
                                        color: '#002E47',
                                        fontFamily: 'Inter',
                                        fontSize: { xs: '24px', md: '32px' },
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '150%'
                                    }}>
                                        Start Free
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        Sign up to turn any knowledge into an interactive course in minutes.
                                    </Typography>
                                </Box>

                                <Box sx={{ width: '100%' }}>
                                    <AuthFirebaseSocials />
                                    <RegisterForm {...this.props} />
                                </Box>
                            </FormCard>
                        </Box>
                    </Box>
                </Container>
            </RootStyle>
        )
    }

    componentDidUpdate() {
        const { snackbar, enqueueSnackbar, dispatch } = this.props
        if (snackbar.messages) {
            snackbar.messages.forEach(message => {
                message.messageIds.forEach(messageId => {
                    enqueueSnackbar(translator._(messageId), {
                        preventDuplicate: true,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        },
                    })
                })
                dispatch(snackbarDispose(message.id))
            })
        }
    }
}

const mapStateToProps = response => ({
    authentication: response.authentication,
    snackbar: response.snackbar,
    process: response.process,
})
export default connect(mapStateToProps)(withSnackbar(McgSignup))
